import React, { useState } from 'react';
import './main.css';
import './mobile-main.css';
import { ReactComponent as Header } from '../../images/header.svg';
import content from '../../data.json';
import Block from '../block/block';

function Main() {
  const data = content.data;
  console.log(data)
  let { blockSizing, setblockSizing } = useState("half");
  return (
    <div className='main'>
      <div className='main__header-image-cotainer'>
        <Header className="main__header-image" alt="COVID-19 Информационный центр"/>
      </div>
      <p className="main__header">{data.info}</p>
      <div className="main__content">
        {
          data && data.blocks.map((block, id) =>
            <Block images={block.images} data={block} number={id + 1} />
          )
        }
      </div>
      <a href="https://ok.ru/rospotrebnadzor.official" target="_blank" style={{ textDecoration: "none" }}>
        <div className="main__button">Подробнее</div>
      </a>
    </div>
  );
}

export default Main;
